import { render, staticRenderFns } from "./ExportPostCost.vue?vue&type=template&id=1e089078&"
import script from "./ExportPostCost.vue?vue&type=script&lang=js&"
export * from "./ExportPostCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports